import { render, staticRenderFns } from "./Companys.vue?vue&type=template&id=1da8a919&scoped=true&"
import script from "./Companys.vue?vue&type=script&lang=js&"
export * from "./Companys.vue?vue&type=script&lang=js&"
import style0 from "./Companys.vue?vue&type=style&index=0&id=1da8a919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8a919",
  null
  
)

export default component.exports